import React from 'react';
import { useTranslation } from './i18n';

export default function UitlegPage({ type = 'kandidaat', onBack }) {
  const { t } = useTranslation();
  const src = type === 'bedrijf' ? '/uitleg_bedrijf.html' : '/uitleg_kandidaat.html';

  return (
    <div style={{ position: 'relative', width: '100vw', height: '100vh', background: '#000' }}>
      <iframe
        src={src}
        title={type === 'bedrijf' ? t('uitleg.company_title') : t('uitleg.candidate_title')}
        style={{ width: '100%', height: '100%', border: 'none' }}
        allowFullScreen
      />
      <button
        onClick={onBack}
        style={{
          position: 'absolute', top: 16, left: 16, zIndex: 50,
          background: 'rgba(255,255,255,.12)', border: '1px solid rgba(255,255,255,.2)',
          borderRadius: 100, color: '#fff', cursor: 'pointer',
          fontFamily: "'DM Sans', sans-serif", fontSize: 13, fontWeight: 600,
          padding: '6px 18px', backdropFilter: 'blur(8px)',
          transition: 'background .2s',
        }}
        onMouseOver={e => e.currentTarget.style.background = 'rgba(255,255,255,.22)'}
        onMouseOut={e => e.currentTarget.style.background = 'rgba(255,255,255,.12)'}
      >
        {t('uitleg.back_button')}
      </button>
    </div>
  );
}
